import { NgModule } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatMenuModule } from '@angular/material/menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatStepperModule } from '@angular/material/stepper'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatRippleModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    imports: [
        MatButtonModule,
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
        MatDialogModule,
        MatIconModule,
        MatTabsModule,
        MatProgressSpinnerModule,
        MatTableModule,
        MatSnackBarModule,
        MatCheckboxModule,
        MatRadioModule,
        MatProgressBarModule,
        MatMenuModule,
        MatExpansionModule,
        MatDividerModule,
        MatAutocompleteModule,
        MatRippleModule,
        MatStepperModule,
        ClipboardModule
    ],
    exports: [
        MatButtonModule,
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
        MatDialogModule,
        MatIconModule,
        MatTabsModule,
        MatProgressSpinnerModule,
        MatTableModule,
        MatSnackBarModule,
        MatCheckboxModule,
        MatRadioModule,
        MatProgressBarModule,
        MatMenuModule,
        MatExpansionModule,
        MatDividerModule,
        MatDatepickerModule,
        MatAutocompleteModule,
        MatRippleModule,
        MatStepperModule,
        MatTooltipModule,
        ClipboardModule
    ],
    declarations: []
})
export class CustomMaterialModule { }
